
export default class ProjectResultsFilter {
    private onlyStationary: boolean = false;
    private onlyOther: boolean = false;

    asQueryString() {
        return `onlyStationary=${this.onlyStationary}`
            + `&onlyOther=${this.onlyOther}`;
    }

    readFromRaw(rawObject: any): ProjectResultsFilter {
        this.onlyStationary = this.isTrue(rawObject['onlyStationary']);
        this.onlyOther = this.isTrue(rawObject['onlyOther']);
        return this;
    }

    private isTrue(value: any) {
        return value === true || value === 'true';
    }

    isOnlyStationary(): boolean {
        return this.onlyStationary;
    }

    isOnlyOther(): boolean {
        return this.onlyOther;
    }
}
